<template>
   <div class="leads-page">
      <div class="mt-3 pt-3">
			<nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='white'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
            <ol class="breadcrumb" style="font-size:24px; line-height: 24px; font-weight:900;">
               <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Proposal Questions</li>
             </ol>
         </nav>
		</div>

      <div>
         <Questions/>
      </div>
      

   </div>
</template>

<script>
import Questions from '@/components/SparkSettings/Questions.vue';

export default {

	components: {
		Questions,
	},

}
</script>